<template>
  <div>
    <CRow class="px-3">
      <CCol class="px-0" lg="12" sm="12">
        <h4 class="my-0 mt-1 mb-3 text-lg">
          <!-- {{ topTitle }}  -->
          {{ descTitle | descCamelCase }}
        </h4>
      </CCol>
      <CCol
        v-if="isAddButton && (level == 0 || level == 1 || level == 2)"
        class="px-0"
        lg="12"
        sm="12"
      >
        <CButton color="info" class="mb-4 px-4" @click="openCreateModal">
          <CIcon name="cil-plus" class="my-0 mb-1 mr-1" /> Tambah
          <!-- size="md" -->
        </CButton>
      </CCol>
    </CRow>
    <CCard>
      <CCardBody>
        <CDataTable
          :items="items"
          :fields="fields"
          hover
          :column-filter="columnFilter"
          sorter
          table-filter
          items-per-page-select
          :items-per-page="10"
          pagination
        >
          <!-- :clickable-rows="clickableRows"
          @row-clicked="clickedRow" -->
          <template #id="{ item }">
            <td
              v-if="clickableRows"
              class="text-blue-500 uppercase hover:text-blue-700"
              style="cursor: pointer"
              @click="clickedRow(item)"
            >
              {{ item.id }}
            </td>
            <td v-else>
              {{ item.id }}
            </td>
          </template>
          <!-- <template #actions> -->
          <template #actions="{ item }">
            <td class="py-2 flex justify-content-center">
              <CButton
                v-if="isEditButton"
                color="warning"
                variant="outline"
                square
                size="sm"
                class="mr-2"
                @click="openEditModal(item)"
              >
                <!-- <font-awesome-icon :icon="['fas', 'pen']" /> -->
                <p>Edit</p>
              </CButton>
              <CButton
                v-if="isDeleteButton"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="openDeleteModal(item.id)"
              >
                <!-- <font-awesome-icon :icon="['fas', 'trash-alt']" /> -->
                <p>Hapus</p>
              </CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: "MasterTable",
  filters: {
    descCamelCase(val) {
      if (!val) return "";
      return val
        .split(" ")
        .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
        .join(" ");
    },
  },
  props: {
    topTitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    descTitle: {
      type: String,
      default: "",
    },
    items: Object,
    fields: Object,
    clickableRows: Boolean,
    isEditButton: {
      type: Boolean,
      default: true,
    },
    isDeleteButton: {
      type: Boolean,
      default: true,
    },
    isAddButton: {
      type: Boolean,
      default: true,
    },
    columnFilter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      level: localStorage.level,
    };
  },
  mounted() {
    this.$store.commit("ui/setTitleHeader", `${this.topTitle}  ${this.title}`);
  },
  emits: [
    "clicked-row",
    "open-create-modal",
    "open-edit-modal",
    "open-delete-modal",
  ],
  methods: {
    clickedRow(item) {
      this.$emit("clicked-row", item);
    },
    openCreateModal() {
      this.$emit("open-create-modal");
    },
    openEditModal(item) {
      this.$emit("open-edit-modal", item);
    },
    openDeleteModal(id) {
      this.$emit("open-delete-modal", id);
    },
  },
};
</script>

<style scoped>
.btn-action-table {
  border: 1px solid #fc8181;
}
</style>
